var getCustomerBillingPortalURL = function getCustomerBillingPortalURL(_ref) {
  var currentGroupId = _ref.currentGroupId,
      currentUrl = _ref.currentUrl,
      authPortalUrl = _ref.authPortalUrl;
  var result = new URL(authPortalUrl);
  result.searchParams.append('redirectToCallable', 'billing-createCustomerPortalSession');
  result.searchParams.append('groupId', currentGroupId);
  result.searchParams.append('returnUrl', currentUrl);
  return result.href;
};

export default getCustomerBillingPortalURL;